// ===========================================
// Vault Tab Component (formerly Environment Tab)
// ===========================================
// Displays files, keys & secrets in a unified vault

import React from 'react';
import { Key, Plus, Paperclip } from 'lucide-react';
import EnvVariableRow from './EnvVariableRow';
import FileUploadZone from '../FileUploadZone';

const EnvironmentTab = ({ 
  project, 
  onAddVariable, 
  onCopy, 
  copiedId, 
  onRequestPassword,
  onFilesUpdated  // Callback when files are uploaded/deleted
}) => {
  // Get project ID (handle both id and _id)
  const projectId = project._id || project.id;
  
  return (
    <div className="project-detail__env">
      {/* Files Section - Above Secrets */}
      <div className="project-detail__files">
        <div className="section-header">
          <h3>
            <Paperclip size={16} />
            Files & Screenshots ({project.files?.length || 0})
          </h3>
        </div>
        
        {/* File upload zone with drag-and-drop support */}
        <FileUploadZone 
          projectId={projectId}
          files={project.files || []}
          onFilesUpdated={onFilesUpdated}
        />
      </div>
      
      {/* Divider between sections */}
      <div className="vault-divider" />
      
      {/* Secrets Section Header with add button */}
      <div className="section-header">
        <h3>Keys & Secrets ({project.envVariables?.length || 0})</h3>
        <button className="btn-primary" onClick={onAddVariable}>
          <Plus size={16} /> Add Secret
        </button>
      </div>
      
      {/* Keys & secrets list */}
      {project.envVariables && project.envVariables.length > 0 ? (
        <div className="env-list">
          {project.envVariables.map(env => (
            <EnvVariableRow 
              key={env._id || env.id} 
              env={env} 
              onCopy={onCopy}
              copiedId={copiedId}
              onRequestPassword={onRequestPassword}
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Key size={48} />
          <p>No secrets yet</p>
          <span>Store your API keys, secrets, and configuration values securely.</span>
        </div>
      )}
    </div>
  );
};

export default EnvironmentTab;

